import React from 'react';
import {getMessage} from 'epic-diesel-common';
import {MessageCode} from '../alert/types';

export interface WarningBarMessageProps {
    messages: Record<string, string>;
    msgCodes: MessageCode[];
}

const WarningBarMessage = React.memo(({messages, msgCodes}: WarningBarMessageProps) => {
    return (
        <>
            {msgCodes.map(msgCode => {
                if (!msgCode) return null;
                return (
                    <p
                        key={msgCode.code}
                        dangerouslySetInnerHTML={{
                            __html: getMessage(messages, msgCode.code, msgCode.args)
                        }}
                    />
                );
            })}
        </>
    );
});

export default WarningBarMessage;
